var map = {
	"./en-US": [
		72,
		1
	],
	"./en-US.json": [
		72,
		1
	],
	"./fr-FR": [
		73,
		2
	],
	"./fr-FR.json": [
		73,
		2
	],
	"./sv-SE": [
		74,
		3
	],
	"./sv-SE.json": [
		74,
		3
	],
	"./vi-VN": [
		75,
		4
	],
	"./vi-VN.json": [
		75,
		4
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 70;
module.exports = webpackAsyncContext;